// React import
import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
// Actions imports
import { hideNotification, showNotification } from "../../actions";
// Styles import
import './NotificationMessage.css'
// Consts imports
import {
    NOTIFICATION_HIDE,
    NOTIFICATION_SHOW
} from "../../consts/consts";

class NotificationMessage extends React.Component {

    constructor(props) {
        super(props);
        this.state = { show: false };
    }

    showNotification = () => {
        const { showNotification, hideNotification } = this.props;

        this.state.show = true;
        setTimeout(() => {
            this.state.show = false;
            hideNotification();
            }, 1500);
    }

    hideNotification = () => {
        const { hideNotification } = this.props;
        const { duration } = this.props.notification;
        setTimeout(() => {
            hideNotification();
        }, duration);
    }

    render () {

        const { status, message } = this.props.notification;

        if(status === NOTIFICATION_SHOW) {
            return(
                <div className={"notification"}>
                    <div className={"notification_message"}>
                    <span className={"notification_message_label noselect"}>
                        {message}
                    </span>
                    </div>
                </div>
            );
        } else if (status === NOTIFICATION_HIDE) {
            return null;
        } else {
            return null;
        }

    }
}

const mapStateToProps = ({notification}) => {
    return {notification};
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        showNotification: showNotification,
        hideNotification: hideNotification
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationMessage);
